DashboardCtrl = ($scope, $location, $filter, $analytics, flash, userInfo) ->
  $analytics.eventTrack('DSB_loaded')

  $scope.hasHistories = true
  $scope.userInfo = userInfo

  $scope.$on "historiesLoaded.gnp.dashboard", (event, hasHistories) ->
    $scope.hasHistories = hasHistories

  $scope.hideHeader = false

  # message handling
  if $location.search().msg_code
    options =
      timeOut: '0'
      extendedTimeOut: '0'
    code = $location.search().msg_code
    flash.warning($filter('translate')("_DASHBOARD.MESSAGES." + code), options)
    $location.search('msg_code', null)

DashboardCtrl.$inject = [
  '$scope'
  '$location'
  '$filter'
  '$analytics'
  'flash'
  'userInfo'
]

module.exports = DashboardCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/dashboard/dashboard-controller.coffee